<template>
  <div>
    <CRow>
      <CCol sm="12">
        <SuppliersTable
          :items="suppliers"
          hover
          striped
          border
          small
          fixed
          caption="Proveedores"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import SuppliersTable from '../components/suppliers/SuppliersTable.vue'
import ws from '../services/suppliers';
import store from '../store'

export default {
  name: 'Suppliers',
  components: { SuppliersTable },
  data: function () {
		return {
            suppliers: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.suppliers = response.data;
    }
    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.suppliers = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
